<template>
	<div class="contest">
		<header id="nav-head" >
			<img @click="change('/')" class="Mahjong_logo" src="../assets/images/Mahjong_logo.png" alt />
			<ul class="navs">
				<li :class="{ active: active === 0 }" @click="scrollTo(1)">Top</li>
				<li :class="{ active: active === 1 }" @click="scrollTo(2)">Live Stream</li>
				<li :class="{ active: active === 3 }" @click="scrollTo(4)">Tournament Prize</li>
				<li :class="{ active: active === 4 }" @click="scrollTo(5)">Rules & Format</li>
				<li :class="{ active: active === 5 }" @click="scrollTo(6)">Game Log</li>
			</ul>
		</header>

		<div class="bowl contents">
			<div class="bowl_info">
				<img class="logo" src="../assets/images/catfood2025/top-logo.png" alt="">
				<img class="event" src="../assets/images/catfood2025/event.png" alt="">
			</div>
			<img class="h5-banner" src="../assets/images/catfood2025/h5-banner.png" alt="">
		</div>

		<div class="finals contents">
			<img class="date" src="../assets/images/catfood2025/date.png" alt="">
			<div class="Comingsoon" v-if="liveShow">The live stream is being prepared. <br>Please stay tuned.</div>
			<div class="finals_bot" v-else>
				<div class="video get">
					<iframe class="Studio_s"
							src="https://www.youtube.com/embed/q8ywTNX3Aws" title="Official Tournament Catfood Bowl - Major Battle of Kirin S3" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
					<!-- <div class="Studio_s" id="studio_s"></div> -->

					<div class="Studio">
						<a class="Studio_size" :href="`https://www.youtube.com/watch?v=j8iwDJZe04M&ab_channel=MahjongSoulOfficial-Yostar`" target="_Blank">Join
							Livestream</a>
					</div>
				</div>
			</div>
		</div>

		<div class="players contents">
			<img class="players_img" src="../assets/images/catfood2025/top16.png" alt />
		</div>

		<div class="contents catfood_tournament">
			<img class="prize" src="../assets/images/catfood2025/prize.png" alt />
		</div>

		<div class="contents rules">
			<img class="rule" src="../assets/images/catfood2025/rules.png" alt="">
			<img class="rule" src="../assets/images/catfood2025/format.png" alt="">
			<img class="rule" src="../assets/images/catfood2025/live-stream.png" alt="">
		</div>

		<div class="gamelog contents">
			<img class="GameLogo" src="../assets/images/contest/GameLog.png" alt />
			<div class="contest_results">
				<div class="respectively">
<!--					<p @click="btn1data" :class="showmode===1 ? 'active' : 'btn1'" class="elimination btn1">Quarter-finals</p>-->
<!--					<div class="bar"></div>-->
<!--					<p @click="btn2data" :class="showmode===2 ? 'active' : 'btn1'" class="finals_s btn2">Semi-finals</p>-->
<!--					<div class="bar"></div>-->
					<p @click="btn3data" :class="showmode ===3 ?'active' : 'btn1'" class="finals_s btn3">Finals</p>
				</div>
				<div class="results">
					<div class="winner" v-if="showmode===1 && Knockout_results.length">
						<div class="winners" v-for="(itme, index) in Knockout_results" :key="index">
							<a :href="itme.url" target="_Blank">
								<img class="view" src="../assets/images/catfood/VIEW.png" alt />
							</a>
							<a @click="copy(index)">
								<p class="inviteCode">{{ itme.shars }}</p>
								<img class="share" src="../assets/images/contest/share.png" alt />
							</a>
							<div class="ranking">
								<p class="Player_ranking">1st</p>
								<p class="Player_name" :class="{ special: itme.st_name.includes('红烧') }">{{ itme.st_name }}
								</p>
								<p class="integral">{{ itme.st_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">2nd</p>
								<p class="Player_name" :class="{ special: itme.nd_name.includes('红烧') }">{{ itme.nd_name }}
								</p>
								<p class="integral">{{ itme.nd_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">3rd</p>
								<p class="Player_name" :class="{ special: itme.rd_name.includes('红烧') }">{{ itme.rd_name }}
								</p>
								<p class="integral">{{ itme.rd_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">4th</p>
								<p class="Player_name" :class="{ special: itme.th_name.includes('红烧') }">{{ itme.th_name }}
								</p>
								<p class="integral">{{ itme.th_bonus }}</p>
							</div>
						</div>
					</div>
					<div class="Comingsoon"  v-if="showmode===1&&!Knockout_results.length">Coming Soon</div>
					<div class="winner" v-if="showmode===2 && semiResult.length">
						<div class="winners" v-for="(itme, index) in semiResult" :key="index">
							<a :href="itme.url" target="_Blank">
								<img class="view" src="../assets/images/catfood/VIEW.png" alt />
							</a>
							<a @click="copy(index)">
								<p class="inviteCode">{{ itme.shars }}</p>
								<img class="share" src="../assets/images/contest/share.png" alt />
							</a>
							<div class="ranking">
								<p class="Player_ranking">1st</p>
								<p class="Player_name" :class="{ special: itme.st_name.includes('红烧') }">{{ itme.st_name }}
								</p>
								<p class="integral">{{ itme.st_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">2nd</p>
								<p class="Player_name" :class="{ special: itme.nd_name.includes('红烧') }">{{ itme.nd_name }}
								</p>
								<p class="integral">{{ itme.nd_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">3rd</p>
								<p class="Player_name" :class="{ special: itme.rd_name.includes('红烧') }">{{ itme.rd_name }}
								</p>
								<p class="integral">{{ itme.rd_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">4th</p>
								<p class="Player_name" :class="{ special: itme.th_name.includes('红烧') }">{{ itme.th_name }}
								</p>
								<p class="integral">{{ itme.th_bonus }}</p>
							</div>
						</div>
					</div>
					<div class="Comingsoon" v-if="showmode===2&&!semiResult.length">Coming Soon</div>
					<div class="winner" v-if="showmode===3 && final_result.length">
						<!-- Coming Soon -->
						<div class="winners" v-for="(itme, index) in final_result" :key="index">
							<a :href="itme.url" target="_Blank">
								<img class="view" src="../assets/images/catfood/VIEW.png" alt />
							</a>
<!--							<a @click="copy(index)">-->
<!--								<p class="inviteCode">{{ itme.shars }}</p>-->
<!--								<img class="share" src="../assets/images/contest/share.png" alt />-->
<!--							</a>-->
							<div class="ranking">
								<p class="Player_ranking">1st</p>
								<p class="Player_name">{{ itme.st_name }}</p>
								<p class="integral">{{ itme.st_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">2nd</p>
								<p class="Player_name">{{ itme.nd_name }}</p>
								<p class="integral">{{ itme.nd_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">3rd</p>
								<p class="Player_name">{{ itme.rd_name }}</p>
								<p class="integral">{{ itme.rd_bonus }}</p>
							</div>
							<div class="ranking">
								<p class="Player_ranking">4th</p>
								<p class="Player_name">{{ itme.th_name }}</p>
								<p class="integral">{{ itme.th_bonus }}</p>
							</div>
						</div>
					</div>
					<div class="Comingsoon" v-if="showmode===3&&!final_result.length">Coming Soon</div>
				</div>

			</div>
		</div>

		<v-catfoot tabId="10"></v-catfoot>

		<v-footer></v-footer>
	</div>
</template>

<script>
import Footer from "@/components/footer.vue";
import CatFooter from "@/components/catfoot.vue";
// import clipboard from "clipboard";
// Vue.prototype.clipboard = clipboard;
let navheight=0
export default {
	name: "CatFoodBowl-BattleofKirinS3",

	components: {
		"v-footer": Footer,
		"v-catfoot": CatFooter,
	},

	data: () => ({
		arrows: false,
		Tile_size: true,
		currentIndex: 1,
		Knockout_player: [
			{
				imgUrl: require("../assets/images/catfood/top16/1.png"),
				avatarimg: require("../assets/images/contest/1_1.png"),
				PlayerName: "chrisgong27",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/2.png"),
				avatarimg: require("../assets/images/contest/2_1.png"),
				PlayerName: "Bobolai",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/3.png"),
				avatarimg: require("../assets/images/contest/3_1.png"),
				PlayerName: "Ericonator",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/4.png"),
				avatarimg: require("../assets/images/contest/4_1.png"),
				PlayerName: "Peleg",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/5.png"),
				avatarimg: require("../assets/images/contest/5_1.png"),
				PlayerName: "LightPinkYoshi",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/6.png"),
				avatarimg: require("../assets/images/contest/6_1.png"),
				PlayerName: "mahjongtest",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/7.png"),
				avatarimg: require("../assets/images/contest/7_1.png"),
				PlayerName: "クリシュタンド",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/8.png"),
				avatarimg: require("../assets/images/contest/8_1.png"),
				PlayerName: "cert",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/9.png"),
				avatarimg: require("../assets/images/contest/9_1.png"),
				PlayerName: "P4",//TODO、、、、、、、
			},
			{
				imgUrl: require("../assets/images/catfood/top16/10.png"),
				avatarimg: require("../assets/images/contest/10_1.png"),
				PlayerName: "主不在乎",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/11.png"),
				avatarimg: require("../assets/images/contest/11_1.png"),
				PlayerName: "janbo",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/12.png"),
				avatarimg: require("../assets/images/contest/12_1.png"),
				PlayerName: "wrathss",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/13.png"),
				avatarimg: require("../assets/images/contest/13_1.png"),
				PlayerName: "DemoKracker",//TODO
			},
			{
				imgUrl: require("../assets/images/catfood/top16/14.png"),
				avatarimg: require("../assets/images/contest/14_1.png"),
				PlayerName: "imacow",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/15.png"),
				avatarimg: require("../assets/images/contest/15_1.png"),
				PlayerName: "Eile",
			},
			{
				imgUrl: require("../assets/images/catfood/top16/16.png"),
				avatarimg: require("../assets/images/contest/16_1.png"),
				PlayerName: "dorksport",
			},
		], //玩家简介

		Knockout_results: [
			{
				st_name: "P4",
				st_bonus: "51400",
				nd_name: "cert",
				nd_bonus: "41000",
				rd_name: "chrisgong27",
				rd_bonus: "27100",
				th_name: "dorksport",
				th_bonus: "-19500",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-0c4743b2-59b1-4cce-9460-1a59feb3c64d_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-0c4743b2-59b1-4cce-9460-1a59feb3c64d_a830443546",
			},
			{
				st_name: "wrathss",
				st_bonus: "45200",
				nd_name: "LightPinkYoshi",
				nd_bonus: "25700",
				rd_name: "Peleg",
				rd_bonus: "22100",
				th_name: "DemoKracker",
				th_bonus: "7000",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-addc0582-a5fc-4894-9730-836bf826e89c_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-addc0582-a5fc-4894-9730-836bf826e89c_a830443546",
			},

			{
				st_name: "Eile",
				st_bonus: "38100",
				nd_name: "クリシュタンド",
				nd_bonus: "27000",
				rd_name: "Bobolai",
				rd_bonus: "20700",
				th_name: "主不在乎",
				th_bonus: "14200",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-1b191d4e-72fe-47f7-9059-3535b4165a47_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-1b191d4e-72fe-47f7-9059-3535b4165a47_a830443546",
			},


			{
				st_name: "Ericonator",
				st_bonus: "40600",
				nd_name: "janbo",
				nd_bonus: "24800",
				rd_name: "imacow",
				rd_bonus: "19100",
				th_name: "mahjongtest",
				th_bonus: "15500",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-a7432f91-a341-4d9d-ac0e-17e02e57388d_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-a7432f91-a341-4d9d-ac0e-17e02e57388d_a830443546",
			},

			{
				st_name: "dorksport",
				st_bonus: "45100",
				nd_name: "chrisgong27",
				nd_bonus: "30900",
				rd_name: "janbo",
				rd_bonus: "19800",
				th_name: "P4",
				th_bonus: "4200",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-0d0d5bd6-a639-4c4d-ac47-89f84d39225f_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-0d0d5bd6-a639-4c4d-ac47-89f84d39225f_a830443546",
			},

			{
				st_name: "Ericonator",
				st_bonus: "35200",
				nd_name: "主不在乎",
				nd_bonus: "32100",
				rd_name: "クリシュタンド",
				rd_bonus: "18800",
				th_name: "Bobolai",
				th_bonus: "13900",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-b0f19647-70b6-4db5-808e-3fc150b87e3b_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-b0f19647-70b6-4db5-808e-3fc150b87e3b_a830443546",
			},

			{
				st_name: "imacow",
				st_bonus: "50700",
				nd_name: "mahjongtest",
				nd_bonus: "43100",
				rd_name: "Eile",
				rd_bonus: "20300",
				th_name: "cert",
				th_bonus: "-14100",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-91d07b2b-46af-4cd1-803e-6dc5b49d090a_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-91d07b2b-46af-4cd1-803e-6dc5b49d090a_a830443546",
			},


			{
				st_name: "Peleg",
				st_bonus: "47000",
				nd_name: "LightPinkYoshi",
				nd_bonus: "37200",
				rd_name: "DemoKracker",
				rd_bonus: "17800",
				th_name: "wrathss",
				th_bonus: "-2000",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-5b3fc7e3-a63c-4db2-aa81-ae711e85b34f_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-5b3fc7e3-a63c-4db2-aa81-ae711e85b34f_a830443546",
			},


			{
				st_name: "DemoKracker",
				st_bonus: "49200",
				nd_name: "mahjongtest",
				nd_bonus: "31600",
				rd_name: "Ericonator",
				rd_bonus: "10100",
				th_name: "Bobolai",
				th_bonus: "9100",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-a0ca175b-8fd2-44d9-9427-387b74242753_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-a0ca175b-8fd2-44d9-9427-387b74242753_a830443546",
			},

			{
				st_name: "クリシュタンド",
				st_bonus: "35100",
				nd_name: "dorksport",
				nd_bonus: "31800",
				rd_name: "LightPinkYoshi",
				rd_bonus: "17700",
				th_name: "P4",
				th_bonus: "15400",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-7118392d-a103-4063-bda6-845e2f2f80d7_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-7118392d-a103-4063-bda6-845e2f2f80d7_a830443546",
			},

			{
				st_name: "Eile",
				st_bonus: "28900",
				nd_name: "imacow",
				nd_bonus: "27800",
				rd_name: "cert",
				rd_bonus: "22300",
				th_name: "chrisgong27",
				th_bonus: "21000",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-bc395346-a704-411b-aa51-361f4e9c16d8_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-bc395346-a704-411b-aa51-361f4e9c16d8_a830443546",
			},

			{
				st_name: "janbo",
				st_bonus: "39700",
				nd_name: "wrathss",
				nd_bonus: "29900",
				rd_name: "Peleg",
				rd_bonus: "20900",
				th_name: "主不在乎",
				th_bonus: "9500",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240118-ac8d0743-b0e6-4703-ae5a-6998f6578d41_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240118-ac8d0743-b0e6-4703-ae5a-6998f6578d41_a830443546",
			},
		], //淘汰赛结果
		semiResult:[
			{
				st_name: "imacow",
				st_bonus: "35600",
				nd_name: "Peleg",
				nd_bonus: "34800",
				rd_name: "Ericonator",
				rd_bonus: "24500",
				th_name: "mahjongtest",
				th_bonus: "5100",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240119-227e3adc-0241-41c9-9461-9fa0a9ed08b3_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240119-227e3adc-0241-41c9-9461-9fa0a9ed08b3_a830443546",
			},
			{
				st_name: "クリシュタンド",
				st_bonus: "40300",
				nd_name: "janbo",
				nd_bonus: "26600",
				rd_name: "LightPinkYoshi",
				rd_bonus: "25800",
				th_name: "Eile",
				th_bonus: "7300",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240119-f04d25a4-4e45-4082-b9a0-0f7f868c0dbc_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240119-f04d25a4-4e45-4082-b9a0-0f7f868c0dbc_a830443546",
			},
			{
				st_name: "Ericonator",
				st_bonus: "57600",
				nd_name: "mahjongtest",
				nd_bonus: "19000",
				rd_name: "クリシュタンド",
				rd_bonus: "15400",
				th_name: "Peleg",
				th_bonus: "8000",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240119-46dade4c-82ce-445d-a364-78976913bed3_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240119-46dade4c-82ce-445d-a364-78976913bed3_a830443546",
			},
			{
				st_name: "LightPinkYoshi",
				st_bonus: "39300",
				nd_name: "janbo",
				nd_bonus: "32800",
				rd_name: "imacow",
				rd_bonus: "19400",
				th_name: "Eile",
				th_bonus: "8500",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240119-a6c053f8-cd73-4114-94d9-e800f86058b6_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240119-a6c053f8-cd73-4114-94d9-e800f86058b6_a830443546",
			},
			{
				st_name: "janbo",
				st_bonus: "41400",
				nd_name: "imacow",
				nd_bonus: "25100",
				rd_name: "クリシュタンド",
				rd_bonus: "23800",
				th_name: "mahjongtest",
				th_bonus: "9700",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240119-dec2c72a-5698-4e35-bea0-1c1ce00e530b_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240119-dec2c72a-5698-4e35-bea0-1c1ce00e530b_a830443546",
			},
			{
				st_name: "Ericonator",
				st_bonus: "34100",
				nd_name: "Peleg",
				nd_bonus: "31300",
				rd_name: "Eile",
				rd_bonus: "26800",
				th_name: "LightPinkYoshi",
				th_bonus: "7800",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=240119-7a1a53b8-b389-4d14-997e-78b7c6d7e51d_a830443546",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=240119-7a1a53b8-b389-4d14-997e-78b7c6d7e51d_a830443546",
			},
		],
		final_result: [
			{
				st_name: "Bobbrik",
				st_bonus: "51400",
				nd_name: "クリシュタンド",
				nd_bonus: "43600",
				rd_name: "redpanda",
				rd_bonus: "25900",
				th_name: "imacow",
				th_bonus: "-900",
				// shars: "https://mahjongsoul.game.yo-star.com/?paipu=240121-c41c521f-7734-4c66-af70-9c9a7af7e5d3_a830443546",
				// url: "https://mahjongsoul.game.yo-star.com/?paipu=240121-c41c521f-7734-4c66-af70-9c9a7af7e5d3_a830443546",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=250908-d23385db-e947-4016-94ad-da7172c93cbb",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=250908-d23385db-e947-4016-94ad-da7172c93cbb",
			},
			{
				st_name: "redpanda",
				st_bonus: "53500",
				nd_name: "imacow",
				nd_bonus: "42900",
				rd_name: "クリシュタンド",
				rd_bonus: "12800",
				th_name: "Bobbrik",
				th_bonus: "10800",
				// shars: "https://mahjongsoul.game.yo-star.com/?paipu=240121-7f905942-81a0-467d-8c5a-e31acd7b2c00_a830443546",
				// url: "https://mahjongsoul.game.yo-star.com/?paipu=240121-7f905942-81a0-467d-8c5a-e31acd7b2c00_a830443546",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=250908-b3bd8579-6fb0-43e6-8205-b51637e49b77",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=250908-b3bd8579-6fb0-43e6-8205-b51637e49b77",
			},
			{
				st_name: "imacow",
				st_bonus: "42900",
				nd_name: "Bobbrik",
				nd_bonus: "27900",
				rd_name: "redpanda",
				rd_bonus: "25100",
				th_name: "クリシュタンド",
				th_bonus: "24100",
				// shars: "https://mahjongsoul.game.yo-star.com/?paipu=240121-b5330650-2093-4a91-8faa-10776362f7aa_a830443546",
				// url: "https://mahjongsoul.game.yo-star.com/?paipu=240121-b5330650-2093-4a91-8faa-10776362f7aa_a830443546",
				shars: "https://mahjongsoul.game.yo-star.com/?paipu=250908-f34b70ed-cb9b-4c4e-93e8-4497dbca9c42",
				url: "https://mahjongsoul.game.yo-star.com/?paipu=250908-f34b70ed-cb9b-4c4e-93e8-4497dbca9c42",
			},
		], //决赛结果
		liveShow: false,

		Player_ability_value: [
			{
				ranking: "NO.01",
				In_game_Name: "mort",
				Rank: "Master 2",
				Favourite_Yaku: "True Nine Gates in Pin",
				Lucky_Tile: require("../assets/images/contest/1_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/7m.png"),
				Been_playing_Mahjong: "15 Years",
				Favourite_Character: "Sawako but it always changes",
				atks: "77",
				def: "67",
				spds: "46",
				luks: "68",
			},
			{
				ranking: "NO.02",
				In_game_Name: "vActv",
				Rank: "Master 2",
				Favourite_Yaku: "Riichi",
				Lucky_Tile: require("../assets/images/contest/2_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/7z.png"),
				Been_playing_Mahjong: "2 Years",
				Favourite_Character: "Miki Nikaidou",
				atks: "51",
				def: "54",
				spds: "40",
				luks: "55",
			},
			{
				ranking: "NO.03",
				In_game_Name: "Elahrairah",
				Rank: "Master 1",
				Favourite_Yaku: "Mixed Triple Sequence",
				Lucky_Tile: require("../assets/images/contest/3_1.png"),
				Lucky_Tile_size: "Whatever the flow brings",
				Lucky_Tile_img: "",
				Been_playing_Mahjong: "4 Months",
				Favourite_Character: "Chiori Mikami",
				atks: "77",
				def: "67",
				spds: "56",
				luks: "83",
			},
			{
				ranking: "NO.04",
				In_game_Name: "aruchomu",
				Rank: "Master 1",
				Favourite_Yaku: "Three Quads",
				Lucky_Tile: require("../assets/images/contest/4_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/4z.png"),
				Been_playing_Mahjong: "1 Year",
				Favourite_Character: "Ichihime",
				atks: "56",
				def: "27",
				spds: "46",
				luks: "53",
			},
			{
				ranking: "NO.05",
				In_game_Name: "Dokku",
				Rank: "Master 2",
				Favourite_Yaku: "Riichi",
				Lucky_Tile: require("../assets/images/contest/5_1.png"),
				Lucky_Tile_size: "Red Dora",
				Lucky_Tile_img: "",
				Been_playing_Mahjong: "8 Years",
				Favourite_Character: "Xenia",
				atks: "80",
				def: "40",
				spds: "16",
				luks: "59",
			},
			{
				ranking: "NO.06",
				In_game_Name: "kuanrongchan",
				Rank: "Master 1",
				Favourite_Yaku: "Thirteen Orphans",
				Lucky_Tile: require("../assets/images/contest/6_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/4m.png"),
				Been_playing_Mahjong: "10 Years",
				Favourite_Character: "Miki Nikaidou ",
				atks: "52",
				def: "61",
				spds: "30",
				luks: "66",
			},
			{
				ranking: "NO.07",
				In_game_Name: "Bobolai",
				Rank: "Master 1",
				Favourite_Yaku: "Thirteen Orphans",
				Lucky_Tile: require("../assets/images/contest/7_1.png"),
				Lucky_Tile_size: "Wind Tiles",
				Lucky_Tile_img: "",
				Been_playing_Mahjong: "2 Years",
				Favourite_Character: "Ein",
				atks: "46",
				def: "78",
				spds: "36",
				luks: "61",
			},
			{
				ranking: "NO.08",
				In_game_Name: "Wave",
				Rank: "Master 1",
				Favourite_Yaku: "After a Kan",
				Lucky_Tile: require("../assets/images/contest/8_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/1z.png"),
				Been_playing_Mahjong: "11 Years",
				Favourite_Character: "Anju Suzumiya",
				atks: "63",
				def: "78",
				spds: "53",
				luks: "70",
			},
			{
				ranking: "NO.09",
				In_game_Name: "Ashyuna ",
				Rank: "Master 2",
				Favourite_Yaku: "Little Three Dragons",
				Lucky_Tile: require("../assets/images/contest/9_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/7m.png"),
				Been_playing_Mahjong: "10 Years",
				Favourite_Character: "Sawako Kitami",
				atks: "44",
				def: "64",
				spds: "36",
				luks: "50",
			},
			{
				ranking: "NO.10",
				In_game_Name: "Hainiryuun",
				Rank: "Master 1",
				Favourite_Yaku: "Full Flush",
				Lucky_Tile: require("../assets/images/contest/10_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/4z.png"),
				Been_playing_Mahjong: "11 Years",
				Favourite_Character: "Xenia",
				atks: "54",
				def: "67",
				spds: "46",
				luks: "65",
			},
			{
				ranking: "NO.11",
				In_game_Name: "Charm",
				Rank: "Master 2",
				Favourite_Yaku: "Riichi",
				Lucky_Tile: require("../assets/images/contest/11_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/1p.png"),
				Been_playing_Mahjong: "1.5 Years",
				Favourite_Character: "Xenia",
				atks: "49",
				def: "67",
				spds: "30",
				luks: "62",
			},
			{
				ranking: "NO.12",
				In_game_Name: "Otakool",
				Rank: "Master 2",
				Favourite_Yaku: "Seven Pairs wait on Dora",
				Lucky_Tile: require("../assets/images/contest/12_1.png"),
				Lucky_Tile_size: "6 Pin or Dora",
				Lucky_Tile_img: "",
				Been_playing_Mahjong: "3 Years",
				Favourite_Character: "Haruna Igarashi",
				atks: "47",
				def: "57",
				spds: "36",
				luks: "58",
			},
			{
				ranking: "NO.13",
				In_game_Name: "bokunoniko",
				Rank: "Master 3",
				Favourite_Yaku: "All Triplets",
				Lucky_Tile: require("../assets/images/contest/13_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/7z.png"),
				Been_playing_Mahjong: "12 Years",
				Favourite_Character: "Chihori Terasaki",
				atks: "36",
				def: "74",
				spds: "43",
				luks: "56",
			},
			{
				ranking: "NO.14",
				In_game_Name: "LightSeeker ",
				Rank: "Master 3",
				Favourite_Yaku: "Seven Pairs",
				Lucky_Tile: require("../assets/images/contest/14_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/2p.png"),
				Been_playing_Mahjong: "9 Years",
				Favourite_Character: "Xenia",
				atks: "63",
				def: "61",
				spds: "40",
				luks: "47",
			},
			{
				ranking: "NO.15",
				In_game_Name: "Subaraaa",
				Rank: "Master 1",
				Favourite_Yaku: "Mixed Triple Sequence",
				Lucky_Tile: require("../assets/images/contest/15_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/5p.png"),
				Been_playing_Mahjong: "5 Years",
				Favourite_Character: "Joseph",
				atks: "59",
				def: "67",
				spds: "30",
				luks: "54",
			},
			{
				ranking: "NO.16",
				In_game_Name: "Mer0v0",
				Rank: "Master 2",
				Favourite_Yaku: "Pure Straight",
				Lucky_Tile: require("../assets/images/contest/16_1.png"),
				Lucky_Tile_size: "",
				Lucky_Tile_img: require("../assets/images/mahjong/5ws.png"),
				Been_playing_Mahjong: "15 Years",
				Favourite_Character: "Mai Aihara",
				atks: "67",
				def: "74",
				spds: "50",
				luks: "80",
			},
		], //玩家详情信息

		Player_ability_values: [], //某一个玩家的详情信息
		showmode: 3, //比赛默认16强淘汰赛选中状态
		knockout: false, //淘汰赛详情
		final: true, //决赛详情
		player_ability: false, //参赛玩家能力
		active: 0, // 当前激活的导航索引
		share: "",
		Comingsoon: false, //遮绕层
		iframePlayer: null,
		setIntervalCount: 10, // 最大轮询次数
		ytTimer: null, // youtube 直播播放定时器对象
	}),

	created() { },

	mounted() {
		if (window.YT) {
			this.initYtPlayer();
		} else {
			this.ytTimer = setInterval(() => {
				if (this.setIntervalCount <= 0) {
					clearInterval(this.ytTimer);
				}

				if (window.YT) {
					this.initYtPlayer();
					clearInterval(this.ytTimer);
				} else {
					this.setIntervalCount -= 1;
				}
			}, 1000);
		}

		// this.$nextTick(() => {
		//   this.drawLine();
		// });
		this.$nextTick(()=>{
			navheight = document.querySelector('#nav-head').clientHeight
			console.log('this.navHeight',navheight)
		})
		window.addEventListener("scroll", this.onScroll, false);
	},
	beforeDestroy() {
		clearInterval(this.ytTimer);
	},
	destroyed() {
		// 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
		window.removeEventListener("scroll", this.onScroll);
	},

	watch: {},

	computed: {
		YTB_ID() {
			return process.env.VUE_APP_CFB_ID;
		},
		HOST() {
			return process.env.VUE_APP_HOST;
		},
		currentPlayer() {
			return function (playerId) {
				return require(`../assets/images/contest/${playerId}.jpg`)
			}
		}
	},
	methods: {
		// 初始化播放器
		initYtPlayer() {
			this.iframePlayer = new window.YT.Player("studio_s", {
				videoId: this.YTB_ID,
				playerVars: {
					autoplay: 1,
					enablejsapi: 1,
					mute: 1,
					origin: `${window.location.protocol}//${window.location.host}`,
				},
				events: {
					onReady: (event) => {
						console.log("[onReady]", event);
						this.iframePlayer.playVideo();
					},
					// onStateChange: function (event) {
					//   console.log("[onStateChange]", event);
					// },
					// onPlaybackQualityChange: function (event) {
					//   console.log("[onPlaybackQualityChange]", event);
					// },
					// onPlaybackRateChange: function (event) {
					//   console.log("[onPlaybackRateChange]", event);
					// },
					// onError: function (event) {
					//   console.log("[onError]", event);
					// },
					// onApiChange: function (event) {
					//   console.log("[onApiChange]", event);
					// },
				},
			});
		},

		//16强淘汰赛详情
		btn1data() {
			this.showmode = 1;
			// if (!this.commingsoon) return false;
			this.final = false;
			this.knockout = true;
		},

		btn2data() {
			this.showmode = 2;
			this.final = true;
			this.knockout = false;
		},
		//决赛详情
		btn3data() {
			this.showmode = 3;
			this.final = true;
			this.knockout = false;
		},
		//显示参赛玩家能力详情表
		hideAbility(index) {
			this.currentIndex = index + 1;
			this.player_ability = true;
			var value = this.Player_ability_value[index];
			if (value.Lucky_Tile_img != "") {
				this.arrows = true;
				this.Tile_size = false;
			} else {
				this.arrows = false;
				this.Tile_size = true;
			}
			this.Player_ability_values.push(value);
			console.log(this.Player_ability_values);
			// for (let i = 0; i < value.length; i++) {
			//   console.log(value[i]);
			// }
		},
		//关闭参赛玩家能力详情表
		showAbility() {
			this.player_ability = false;
		},
		// 滚动监听器
		onScroll() {
			// 获取所有锚点元素
			const navContents = document.querySelectorAll(".contents");

			// 所有锚点元素的 offsetTop
			const offsetTopArr = [];
			navContents.forEach((item) => {
				offsetTopArr.push(item.offsetTop-navheight);
			});
			// 获取当前文档流的 scrollTop
			const scrollTop =
				document.documentElement.scrollTop || document.body.scrollTop;
			// 定义当前点亮的导航下标
			let navIndex = 0;
			for (let n = 0; n < offsetTopArr.length; n++) {
				// 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
				// 那么此时导航索引就应该是n了
				if (scrollTop >= offsetTopArr[n]-5) {
					navIndex = n;
				}
			}
			this.active = navIndex;
		},
		// 跳转到指定索引的元素
		scrollTo(index) {
			// 获取目标的 offsetTop
			// css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
			const targetOffsetTop = document.querySelector(
				`.contents:nth-child(${index + 1})`
			).offsetTop;
			// 获取当前 offsetTop
			let scrollTop =
				document.documentElement.scrollTop || document.body.scrollTop;
			// 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
			const STEP = 50;
			// 判断是往下滑还是往上滑
			if (scrollTop > targetOffsetTop) {
				// 往上滑
				smoothUp();
			} else {
				// 往下滑
				smoothDown();
			}
			// 定义往下滑函数
			function smoothDown() {
				// 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
				if (scrollTop < targetOffsetTop) {
					// 如果和目标相差距离大于等于 STEP 就跳 STEP
					// 否则直接跳到目标点，目标是为了防止跳过了。
					if (targetOffsetTop - scrollTop >= STEP) {
						scrollTop += STEP;
					} else {
						scrollTop = targetOffsetTop;
					}
					document.body.scrollTop = scrollTop;
					document.documentElement.scrollTop = scrollTop-navheight;
					// 关于 requestAnimationFrame 可以自己查一下，在这种场景下，相比 setInterval 性价比更高
					requestAnimationFrame(smoothDown);
				}
			}
			// 定义往上滑函数
			function smoothUp() {
				if (scrollTop > targetOffsetTop) {
					if (scrollTop - targetOffsetTop >= STEP) {
						scrollTop -= STEP;
					} else {
						scrollTop = targetOffsetTop;
					}
					document.body.scrollTop = scrollTop;
					document.documentElement.scrollTop = scrollTop - navheight;
					requestAnimationFrame(smoothUp);
				}
			}
		},
		// 跳转首页
		change(path) {
			this.$router.push(path);
		},
		//点击复制比赛链接
		copy(index) {
			var Url2 =
				document.getElementsByClassName("inviteCode")[index].innerText;
			console.log(Url2);
			var oInput = document.createElement("input");
			oInput.value = Url2;
			document.body.appendChild(oInput);
			oInput.select(); // 选择对象
			document.execCommand("Copy"); // 执行浏览器复制命令
			oInput.className = "oInput";
			oInput.style.display = "none";
			alert("Copy successful");
		},
	},
};
</script>

<style lang="scss" scoped>
.contest {
	-moz-user-select: -moz-none;
	-moz-user-select: none;
	-o-user-select: none;
	-khtml-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	user-select: none;
	width: 100%;
	background: url('../assets/images/catfood2025/bg.jpg') no-repeat;
	background-attachment: fixed;
	background-size: 100% 100%;
	background-position: center center;
	text-align: center;
	background-size: cover;
	padding-top: pxTorem(50px);

	header {
		z-index: 998;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		height: pxTorem(72px);
		background: rgba(0, 0, 0, 0.8);

		.Mahjong_logo {
			cursor: pointer;
			position: absolute;
			display: block;
			width: pxTorem(209px);
			top: pxTorem(0px);
			left: pxTorem(20px);
		}

		ul {
			margin-left: pxTorem(234px);
			color: white;
			display: flex;
			height: 100%;
			line-height: pxTorem(72px);
			font-size: pxTorem(30px);

			li {
				white-space: nowrap;
				font-family: "okakd";
				font-style: italic;
				box-sizing: border-box;
				padding: 0 pxTorem(42px);
				cursor: pointer;
			}

			.active {
				color: white;
				text-shadow: 0px 0px pxTorem(50px) #fdebea,
					0px 0px pxTorem(20px) #5c4061, 0px 0px pxTorem(20px) #7a5276,
					0px 0px pxTorem(20px) #7b5378;
				position: relative;

				// background-color: #e2e2e2;
				&::after {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					right: pxTorem(7px);
					width: pxTorem(40px);
					height: pxTorem(40px);
					background: url("../assets/images/catfood/heart.png") no-repeat;
					background-size: 100%;
					content: "";
				}
			}
		}
	}

	.bowl {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		height: pxTorem(700px);
		background: url(../assets/images/catfood2025/top-role.png) no-repeat right bottom;
		background-size:  contain;

		.bowl_info {
			position: absolute;
			display: flex;
			flex-direction: column;
			align-items: center;
			left: pxTorem(150px);
			top: pxTorem(55px);
			.logo {
				width: pxTorem(400px);
			}
			.event {
				width: pxTorem(250px);
				margin-right: pxTorem(50px);
			}
		}
		.h5-banner {
			display: none;
		}

	}

	.finals {
		display: flex;
		flex-direction: column;

		padding: pxTorem(54px) pxTorem(184px) pxTorem(80px) pxTorem(198px);
		//background: rgba(0, 0, 0, .4);
		.date{
			width: pxTorem(480px);
		}
		.finals_size {
			font-family: "Debold";
			height: pxTorem(21px);
			border-left: pxTorem(7px) solid #FFF06E;
			font-size: pxTorem(17px);
			line-height: pxTorem(21px);
			color: white;
			text-align: left;
			padding-left: pxTorem(6px);
		}

		.finals_size_s {
			margin: pxTorem(4px) 0 pxTorem(11px);
		}

		.finals_bot {
			padding: pxTorem(24px) 0 0 pxTorem(16px);
			display: flex;
			justify-content: space-between;
			margin: 0 auto;


			.video {
				width: 100%;
				cursor: pointer;
				position: relative;

				&::v-deep .Studio_s {
					width: 100%;
					height: 100%;
					z-index: 999;
				}

				.Studio {
					color: white;
					font-family: "hyyr";
					font-size: pxTorem(20px);
					background: rgba(0, 0, 0, 0);
					display: none;
					height: 90%;
					// display: none;
					width: 100%;
					text-align: center;

					.Studio_size {
						opacity: 0.6;
						color: white;
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
			.get {
				border: pxTorem(2px) solid #c3bcbf;
				width: pxTorem(879px);
				height: pxTorem(508px);
				background: black;
			}
			.video:hover .Studio {
				display: block;
			}

			.dialogue {
				width: pxTorem(272px);
			}

			.Comments {
				width: 100%;
				height: 100%;
			}
		}

		.Comingsoon {
			font-family: "Debold";
			width: 100%;
			background: rgba(0, 0, 0, 0.6);
			color: white;
			height: pxTorem(500px);
			// position: absolute;
			font-size: pxTorem(30px);
			top: pxTorem(54px);
			line-height: pxTorem(50px);
			align-items: center;
			display: flex;
			justify-content: center;
		}
	}

	.players {
		padding: 0 0 pxTorem(80px);
		//background: rgba(0, 0, 0, .61);
		.players_img {
			width: pxTorem(1000px);
			margin: 0 auto;
		}

		.Players_logo {
			margin-top: pxTorem(47px);
			width: pxTorem(396px);
			margin-bottom: pxTorem(27px);
		}

		.player_information {
			display: flex;
			flex-wrap: wrap;
			align-content: space-between;
			justify-content: space-between;
			// margin-bottom: pxTorem(140px);
			position: relative;

			.introduce {
				cursor: pointer;
				width: pxTorem(196px);
				height: pxTorem(88px);
				background: white;
				margin-bottom: pxTorem(20px);
				position: relative;
				cursor: pointer;

				.introduce_bk {
					width: 100%;
					height: 100%;
				}

				.Player_avatar {
					position: absolute;
					width: pxTorem(56px);
					top: pxTorem(15px);
					left: pxTorem(20px);
				}

				p {
					font-family: "Debold";
					text-align: left;
					left: pxTorem(108px);
					top: pxTorem(54px);
					width: pxTorem(78px);
					word-break: break-word;
					font-size: pxTorem(8px);
					position: absolute;
					z-index: 2;
					color: #966630;
					line-height: pxTorem(14px);
				}
			}

			.details_information {
				width: 100%;
				height: 100%;
				// background: chartreuse;
				z-index: 10;
				position: absolute;

				.player_ability {
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					position: absolute;
					width: pxTorem(347px);
					height: pxTorem(466px);
					background-size: cover;

					.img-wrapper {
						position: absolute;
						left: 0;
						top: 0;
					}

					.paipin {
						width: 100%;
						height: 100%;
						box-sizing: border-box;
						padding-top: pxTorem(82px);
						padding-left: pxTorem(30px);
						text-align: left;
						color: white;
						font-size: pxTorem(8px);
						position: relative;

						.stable {
							left: pxTorem(18px);
							top: pxTorem(7.5px);
							position: absolute;
							font-size: pxTorem(7.5px);
							font-family: "微软雅黑";
						}

						.stabletwo {
							left: pxTorem(140px);
						}

						span {
							position: absolute;
							font-family: "EVOGRIA";
							font-size: pxTorem(50px);
							right: pxTorem(8px);
							top: pxTorem(23px);
						}

						.photo {
							border-radius: pxTorem(7px);
							right: pxTorem(10px);
							position: absolute;
							height: pxTorem(104px);
							width: pxTorem(104px);

							img {
								width: 100%;
								height: 100%;
							}
						}

						.year {
							font-size: pxTorem(10px);
							margin: pxTorem(6px) 0 pxTorem(12px) pxTorem(10px);
						}

						.Instructions {
							width: pxTorem(58px);
							margin-top: pxTorem(5px);
							margin-left: pxTorem(10px);
							margin-bottom: pxTorem(20px);
						}

						.card {
							width: pxTorem(21px);
							position: absolute;
							left: pxTorem(106px);
							top: pxTorem(188px);
						}

						.atk {
							color: #ff808f;
							margin-top: pxTorem(6px);
							width: pxTorem(46px);
							line-height: pxTorem(9px);
							font-size: pxTorem(9px);
							display: flex;
							justify-content: space-between;
							margin-left: pxTorem(11px);
							font-family: "msyhbd";

							.Stats {
								color: white;
							}

							.atks {
								font-weight: 600;
							}

							.def {
								color: #8fffb8;
								font-weight: 600;
							}

							.spds {
								color: #6aacd5;
								font-weight: 600;
							}

							.luks {
								color: #ecc76e;
								font-weight: 600;
							}
						}
					}

					.restart {
						cursor: pointer;
						position: absolute;
						left: pxTorem(-36px);
						top: pxTorem(-26px);
						width: pxTorem(34px);
					}
				}
			}
		}
	}

	.catfood_tournament {
		padding: 0 0 pxTorem(80px);
		.prize {
			max-width: pxTorem(1000px);
		}
	}

	.rules {
		//padding-top: pxTorem(50px);
		.rule {
			margin-bottom: pxTorem(100px);
			max-width: pxTorem(1000px);
		}
	}

	.gamelog {
		padding: 0 pxTorem(260px) pxTorem(73px);

		.GameLogo {
			width: pxTorem(266px);
			margin-bottom: pxTorem(13px);
		}

		.contest_results {
			position: relative;

			.respectively {
				font-size: pxTorem(17px);
				background: rgba(0, 0, 0, 0.3);
				height: pxTorem(35px);
				line-height: pxTorem(35px);
				width: 100%;
				margin-bottom: pxTorem(20px);
				display: flex;
				justify-content: center;
				color: #878787;
				font-family: "hyzt";
				position: relative;
				display: flex;
				align-items: center;
				.cut-off {
					position: absolute;
					top: 20%;
					height: pxTorem(24px);
					width: pxTorem(2px);
					background: white;
					transform: translate(-50% -50%);
				}

				.elimination {
					cursor: pointer;
				}

				.finals_s {
					cursor: pointer;
				}
				.bar{
					margin: 0 pxTorem(42px);
					width: pxTorem(1px);
					height: pxTorem(23px);
					background: #FFFFFF;
				}
				.btn1.active,
				.btn2.active,
				.btn3.active{
					cursor: pointer;
					color: white;
					text-shadow: 0px pxTorem(-5px) pxTorem(10px) #ff65aa,
						pxTorem(-10px) 0px pxTorem(12px) #ff65aa,
						pxTorem(5px) 0px pxTorem(10px) #ff65aa,
						0px pxTorem(5px) pxTorem(10px) #ff65aa;
				}
			}

			.results {

				// overflow-y: scroll;
				// height: pxTorem(478px);
				.winner1 {
					width: 55vw;
					height: 62.3vh;
					background: #0b0c0e;
					border: pxTorem(2px) solid #ffffff;
					opacity: 0.74;
					border-radius: pxTorem(6px);
					font-family: "Debold";
					color: #fff;
					text-align: center;
					line-height: 62.3vh;
					margin: 0 auto;
				}

				.winner {
					.winners {
						box-sizing: border-box;
						padding: pxTorem(19px) pxTorem(118px) pxTorem(19px) pxTorem(34px);
						margin-left: pxTorem(31px);
						border-radius: pxTorem(5px);
						width: pxTorem(722px);
						height: pxTorem(85px);
						border: pxTorem(2px) solid white;
						margin-bottom: pxTorem(13px);
						display: flex;
						flex-wrap: wrap;
						align-content: space-between;
						justify-content: space-between;
						position: relative;
						background: rgba(0, 0, 0, 0.6);

						a {
							position: absolute;
							top: pxTorem(26px);
							left: pxTorem(630px);

							.view {
								//top: pxTorem(-20px);
								//width: pxTorem(72px);
								//position: absolute;
							}

							.share {
								cursor: pointer;
								width: pxTorem(72px);
								position: absolute;
								top: pxTorem(12px);
							}

							.inviteCode {
								display: none;
							}
						}

						.ranking {
							font-family: "Debold";
							width: pxTorem(261px);
							height: pxTorem(18px);
							position: relative;
							display: flex;
							font-size: pxTorem(14px);
							line-height: pxTorem(18px);

							p {
								line-height: pxTorem(18px);
							}

							.Player_ranking {
								color: #ff7064;
							}

							.Player_name {
								color: white;
								margin-left: pxTorem(18px);
								//
							}

							.integral {
								position: absolute;
								right: 0;
								color: #ffdc9e;
							}
						}
					}
				}
			}

			.Comingsoon {
				font-family: "Debold";
				width: 100%;
				background: rgba(0, 0, 0, 0.6);
				color: white;
				height: pxTorem(500px);
				// position: absolute;
				font-size: pxTorem(30px);
				top: pxTorem(54px);
				line-height: pxTorem(500px);
			}
		}
	}
	.contents{
		position: relative;
		z-index: 2;
	}
	.special {
		font-family: "hkktlw9" !important;
	}

	/* 滚动条宽度 */
	::-webkit-scrollbar {
		width: pxTorem(5px);
		height: 0px;
	}

	/* 滚动条的滑块 */
	::-webkit-scrollbar-thumb {
		background-color: white;
		border-radius: pxTorem(2px);
	}

	/* 滚动条的滑槽 */
	::-webkit-scrollbar-track {
		width: pxTorem(14px);
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		border-radius: pxTorem(5px);
		background-color: #0d0e11;
	}
}

@media screen and (max-width: 600px) {
	.contest {
		background-image: url('../assets/images/catfood2025/h5-bg.jpg');
		header {
			height: MpxTorem(32px);

			.Mahjong_logo {
				width: MpxTorem(60px);
				top: MpxTorem(5px);
				left: MpxTorem(15px);
			}

			ul {
				margin-left: MpxTorem(70px);
				line-height: MpxTorem(32px);
				font-size: MpxTorem(10px);

				li {
					padding: 0 MpxTorem(10px);
				}

				.active {
					color: white;
					text-shadow: 0px 0px pxTorem(50px) #fdebea,
					0px 0px pxTorem(20px) #5c4061,
					0px 0px pxTorem(20px) #7a5276,
					0px 0px pxTorem(20px) #7b5378;
					position: relative;

					// background-color: #e2e2e2;
					&::after {
						position: absolute;
						bottom: MpxTorem(1px);
						right: MpxTorem(-7px);
						width: MpxTorem(20px);
						height: pxTorem(40px);
						background: url("../assets/images/catfood/heart.png") no-repeat;
						background-size: 100%;
						content: "";
					}
				}
			}
		}

		.bowl {
			overflow: hidden;
			width: 100%;
			height: auto;
			background: none;

			.h5-banner {
				display: block;
				width: 100%;
			}

			.bowl_info {
				display: none;
			}
		}

		.finals {
			padding: pxTorem(50px) pxTorem(20px) pxTorem(50px);

			.finals_bot {
				width: 100%;
				padding-top: pxTorem(25px);
				.get {
					width: 100%;
				}
			}
			.Comingsoon {
				font-size: MpxTorem(17px);
			}
		}

		.players, .catfood_tournament, .rules {
			padding: pxTorem(50px) 0 0 0;
			.players_img, .prize, .rule {
				width: 90%;
			}
		}

		.rules .rule {
			margin-bottom: pxTorem(50px);
		}

		.gamelog {
			padding: 0 5% pxTorem(50px) 5%;

			.contest_results .results .winner .winners {
				margin-left: 0;
				width: 100%;
				padding: pxTorem(15px) pxTorem(95px) pxTorem(15px) pxTorem(15px);

				.ranking {
					width: pxTorem(200px);
				}

				a {
					top: pxTorem(28px);
					left: auto;
					right: MpxTorem(10px);

					.view {
						width: pxTorem(60px);
					}
				}
			}
		}

	}
}
</style>
